module.exports = __webpack_public_path__ + "img/gi.044a5bf4.svg";